import { path, prop, toPairs, compose, map, filter } from 'ramda';
import React, { useContext } from 'react';
import Page from '../Page';
import { FsmContext } from '../Provider';

const makePage = ([
  key,
  {
    config: { component },
  },
]) => <Page key={key} state={key} component={component} />;
const makePages = compose(
  map(makePage),
  toPairs,
  filter(path(['config', 'component'])),
  prop('states'),
);

const Workflow = () => {
  const machine = useContext(FsmContext);
  return <React.Fragment>{makePages(machine)}</React.Fragment>;
};

export default Workflow;
